import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import Tooltip from "@mui/material/Tooltip";
import PersonIcon from "@mui/icons-material/Person";
import msg from "../../../assets/images/addmessage.png";
import { useNavigate } from "react-router-dom";
const ToolActionMenu = ({
  row,
  onDownload,
  onAdd,
  onWorkAssign,
  onSwapCategory,
  onMessageSend,
  onBack,
}) => {
  const navigate = useNavigate();
  return (
    <div className="d-flex justify-content-start">
      <div className="d-flex justify-content-between gap-1">
        {onDownload && (
          <Tooltip title="Download Enquiry">
            <div
              onClick={onDownload}
              className="d-flex align-items-center"
              type="button"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                class="bi bi-download"
                viewBox="0 0 16 16"
              >
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
              </svg>
            </div>
          </Tooltip>
        )}
        {onAdd && (
          <Tooltip title="Add Enquiry">
            <div
              onClick={onAdd}
              className="d-flex align-items-center"
              type="button"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                fill="currentColor"
                className="bi bi-plus-circle"
                viewBox="0 0 16 16"
              >
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
              </svg>
            </div>
          </Tooltip>
        )}
        {onWorkAssign && (
          <Tooltip title="Work Assign">
            <div
              onClick={onWorkAssign}
              className="d-flex align-items-center"
              type="button"
            >
              <PersonIcon />
            </div>
          </Tooltip>
        )}
        {onSwapCategory && (
          <Tooltip title="Change Category">
            <div
              onClick={onSwapCategory}
              className="d-flex align-items-center"
              type="button"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                fill="currentColor"
                className="bi bi-arrow-left-right "
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5"
                />
              </svg>
            </div>
          </Tooltip>
        )}
        {onMessageSend && (
          <Tooltip title="Send Messages">
            <div
              onClick={onMessageSend}
              className="d-flex align-items-center"
              type="button"
            >
              <img src={msg} alt="msg" height={23} width={23} />
            </div>
          </Tooltip>
        )}
        {onBack && (
          <button
            className="btn btn-outline-secondary d-flex align-items-center ms-1"
            onClick={onBack}
            style={{
              cursor: "pointer",
            }}
          >
            Back
          </button>
        )}
      </div>
    </div>
  );
};

export default ToolActionMenu;
